module.exports = __webpack_public_path__ + "static/media/logo18.905ecc95.jpg";